import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { spacing } from 'syf-component-library/defaultTheme';
import { Grid, RadioGroup } from 'syf-component-library/ui/patterns';
import { getPaymentMethodsFromPaymentEnterpriseEligibility } from '../../../../helpers';
import { getPaymentTypeError } from '../../../../helpers/getPaymentMethodErrorMessage';
import useApiMachine from '../../../../hooks/machines/useApiMachine';
import PaymentMethodSelectorOption from './PaymentMethodSelectorOption';
const PaymentMethodRadioGroup = styled(RadioGroup) `
  flex-wrap: wrap;
  gap: ${spacing.base}px;
`;
const PaymentMethodTypeSelector = ({ errorMessage, featureFlags, paymentMethodType, productType, handlePaymentMethodTypeChange }) => {
    const [apiMachine] = useApiMachine();
    const { data: paymentEnterpriseEligibility } = apiMachine.context.paymentEnterpriseEligibilityQueryResult;
    const paymentTypeError = getPaymentTypeError(errorMessage);
    const paymentMethodOptions = getPaymentMethodsFromPaymentEnterpriseEligibility(productType, paymentEnterpriseEligibility, featureFlags);
    return (_jsx(Grid, { children: _jsx(PaymentMethodRadioGroup, Object.assign({ dataCy: "payment-method-types", direction: "row", radioType: "chip", selected: paymentMethodType, onChange: handlePaymentMethodTypeChange }, { children: paymentMethodOptions.map((paymentMethod) => {
                return (_jsx(PaymentMethodSelectorOption, { featureFlags: featureFlags, handlePaymentMethodTypeChange: handlePaymentMethodTypeChange, isPaymentTypeError: paymentTypeError === paymentMethod, productType: productType, selected: paymentMethodType === paymentMethod, type: paymentMethod }, paymentMethod));
            }) })) }));
};
export default PaymentMethodTypeSelector;
